import { OfficeApp } from './OfficeApp';
import { officeAppToUrl } from './officeAppToUrl';
import { IOverflowSetItemProps } from '@fluentui/react/lib/OverflowSet';
import onOfficeAppClick from './actions/onOfficeAppClick';
import * as trace from 'owa-trace';

const EXCEL_SVG = require('./resources/Excel_16x.svg');
const ONEDRIVE_SVG = require('./resources/OneDrive_16x.svg');
const POWERPOINT_SVG = require('./resources/PowerPoint_16x.svg');
const WORD_SVG = require('./resources/Word_16x.svg');

export default function getOfficeAppItem(
    app: OfficeApp,
    name: string,
    isHorizontal: boolean
): IOverflowSetItemProps | null {
    const url: string | null = officeAppToUrl(app);

    if (url === null) {
        return null;
    }

    let svgPath;
    switch (app) {
        case 'Word':
            svgPath = WORD_SVG;
            break;
        case 'Excel':
            svgPath = EXCEL_SVG;
            break;
        case 'Powerpoint':
            svgPath = POWERPOINT_SVG;
            break;
        case 'OneDrive':
            svgPath = ONEDRIVE_SVG;
            break;
        case 'Placeholder':
            svgPath = '';
            break;
        default:
            trace.errorThatWillCauseAlert('Svg does not exist for app ' + app);
            svgPath = '';
            break;
    }

    return {
        key: name,
        text: name,
        ariaLabel: name,
        name: name,
        app: app,
        href: url,
        iconProps: {
            imageProps: {
                src: svgPath,
                width: 16,
                height: 16,
                shouldFadeIn: false,
            },
        },
        onClick: () => {
            onOfficeAppClick(app, isHorizontal);
        },
        isSelected: false,
        openInNewTab: true,
    };
}
